// extracted by mini-css-extract-plugin
module.exports = {"container":"_36cDyA","input":"_3WAZHf","switcher":"_1jQahN mz-switch","disabled":"tmKMZD","on":"_14ZIOj mz-switch--on","label":"_3uankN","verbose":"_1K7zmO"};